import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

@Injectable()
export class CoreService {
    constructor(private http: Http) { }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/core/shared/core.service.ts